import $axios from "@/common/http"  //导入封装的axios

export function checkcCertificate(data:any){
    return $axios.get("/exam/checkcCertificate",{params:data})
}
// 
export function searchExamResult(token:any){
    return $axios.get("/exam/searchExamResult",{headers:{token}})
}

export function downLoadExamResult(data:any,token:any){
    return $axios.get("/exam/downLoadExamResult?certificateNumber="+data,{responseType: "blob",headers:{"Content-Disposition": "attachment;filename=pdf","Content-Type": "multipart/form-data;charset=ISO-8859-1",token}})
}

export function selectCertificateImage(data:any,token:any){
    return $axios.get("/exam/selectCertificateImage?certificateNumber="+data,{headers:{token}})
}

export function listMe(token:any){
    return $axios.get("/exam/listMe",{headers:{token}})
}